var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"data-cy":"call-to-action"}},[_c('p',{staticClass:"call-to-action"},[_vm._v(_vm._s(_vm.message))])])
}
var staticRenderFns = []

export { render, staticRenderFns }